import React, { useState } from 'react';
import { uploadImage, STORAGE_PATHS } from '../../services/firebase-storage.js';
import { API } from '../../utils/database-frontend.js';

const DocumentForm = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.description || !formData.image) {
      onError('❌ Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    
    try {
      // Upload image to Firebase Storage
      const uploadResult = await uploadImage(
        formData.image,
        STORAGE_PATHS.DOCUMENTS,
        `document-${Date.now()}.${formData.image.name.split('.').pop()}`
      );

      // Add to database
      const documentData = {
        Title: formData.title,
        Description: formData.description,
        ImageUrl: uploadResult.url,
        FirebaseImagePath: uploadResult.path
      };

      console.log('Sending document data to backend:', documentData);
      const result = await API.documents.create(documentData);
      console.log('Backend response:', result);
      
      onSuccess('✅ Belge başarıyla eklendi!');
      
      // Reset form
      setFormData({
        title: '',
        description: '',
        image: null
      });
      
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      onError('❌ Belge eklenirken hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">📄 Yeni Belge Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Belge Başlığı
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-orange"
            placeholder="Örn: TS EN 206-1 Sertifikası"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Açıklama
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-orange"
            placeholder="Belge hakkında detaylı açıklama..."
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Belge Görseli
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-orange"
            required
          />
          <p className="text-sm text-gray-500 mt-1">
            JPG, PNG veya WEBP formatında görsel yükleyebilirsiniz.
          </p>
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 px-4 rounded-md text-white font-medium ${
            loading
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-brand-orange hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-brand-orange'
          }`}
        >
          {loading ? 'Ekleniyor...' : 'Belge Ekle'}
        </button>
      </form>
    </div>
  );
};

export default DocumentForm; 